import React from "react";
import { FeedLikeType, UserFeedsType } from "../../types";
import {
  UserFeedMenu,
  UserFeedOption,
  UserFeedContent,
  UserActivity,
  UserFeedModal,
  UserFeedImages,
  UserFeedVideo,
  UserFeedImageVideo,
} from "..";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "@apollo/client";
import { GET_FEED_LIKES } from "../../apollo/operations";
import useBodyScrollLock from "../../utils/useBodyScrollLock";
import { setLikedPost } from "../../redux/slices/communityFeedSlice";

type UserFeedListProps = {
  userFeed: UserFeedsType | undefined;
  refetch: () => void;
  isLoading: boolean;
};
const UserFeedList: React.FC<UserFeedListProps> = ({
  userFeed,
  refetch,
  isLoading,
}) => {
  const textareaRef = React.useRef<HTMLTextAreaElement | null>(null);
  const inputArea = React.useRef<HTMLInputElement | null>(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [showAllImages, setShowAllImages] = React.useState<number | null>(null);
  const [editContent, setEditContent] = React.useState(false);
  const [isLocked, toggle] = useBodyScrollLock();

  const [feedLikes, setFeedLikes] = React.useState<FeedLikeType | undefined>(
    {} as any
  );
  const [loadings, setLoadings] = React.useState(false);
  const [modalRemove, setModalRemove] = React.useState(false);

  const dispatch = useDispatch();
  const { refetch: refetchLikes, loading: loadLikes } = useQuery(
    GET_FEED_LIKES,
    {
      variables: {
        where: {
          userFeed: {
            id: userFeed?.id,
          },
        },
      },
      notifyOnNetworkStatusChange: true,
      onCompleted: (data) => {
        // console.log(data);
        setFeedLikes(data);
        dispatch(setLikedPost(data));
        if (!loadLikes) {
          setLoadings(false);
        }
      },
    }
  );

  const handleOnOpen = () => {
    if (typeof toggle === "function") {
      toggle();
    }
    setOpenModal(true);
  };

  const handleOnClose = () => {
    if (typeof toggle === "function") {
      toggle();
    }
    setOpenModal(false);
  };

  React.useState(() => {
    if (typeof toggle === "function" && isLocked === true) {
      toggle();
      if (openModal) {
        handleOnClose();
      }
    }
  });
  const user = useSelector((state: any) => state.user.userDetails);

  const Vid_Img = userFeed?.media;

  return (
    <div
      className="rounded lg:shadow bg-white flex flex-col items-center mb-3 lg:mb-0 py-4 relative overflow-hidden"
      key={userFeed?.id! + userFeed?.createdAt}
    >
      <div className="w-full mx-auto justify-between h-10 px-4 flex mb-3 relative">
        <UserFeedMenu userFeed={userFeed} />
        <UserFeedOption
          userFeed={userFeed}
          setEditContent={setEditContent}
          refetch={refetch}
          toggle={toggle}
        />
      </div>
      {Vid_Img?.map((a) => (
        <UserFeedContent
          userFeed={userFeed}
          feedImages={a.imageUrl}
          feedVideo={a.videoUrl}
          editContent={editContent}
          setEditContent={setEditContent}
          refetch={refetch}
          content={userFeed?.content}
          isLocked={isLocked}
          toggle={toggle}
        />
      ))}

      {Vid_Img &&
        Vid_Img?.map((a, index) =>
          a.imageUrl &&
          a.videoUrl &&
          a.imageUrl.length > 0 &&
          a.videoUrl.length > 0 ? (
            <UserFeedImageVideo
              selectedVideos={a.videoUrl}
              imageUpload={a.imageUrl}
              setShowAllImages={setShowAllImages}
              showAllImages={showAllImages}
              toggle={toggle}
              isLocked={isLocked}
            />
          ) : a.imageUrl && a.imageUrl.length > 0 ? (
            <UserFeedImages
              editCotent={editContent}
              key={index + 1}
              setShowAllImages={setShowAllImages}
              showAllImages={showAllImages}
              feedImages={a.imageUrl}
              toggle={toggle}
              isLocked={isLocked}
            />
          ) : (
            a.videoUrl &&
            a.videoUrl.length > 0 && (
              <UserFeedVideo
                videos={a.videoUrl}
                key={index + 47}
                setShowAllVideos={setShowAllImages}
                showAllVideos={showAllImages}
              />
            )
          )
        )}

      <UserActivity
        textArea={textareaRef}
        openModal={openModal}
        onOpen={handleOnOpen}
        refetch={refetchLikes}
        user={user}
        setLoadings={setLoadings}
        inputArea={inputArea}
        userFeed={userFeed}
        feedLikes={feedLikes}
        refetchAllUserFeeds={refetch}
        setModalRemove={setModalRemove}
      />
      <div className=" lg:overflow-auto h-full px-4">
        {Vid_Img?.map((medias, index) => (
          <UserFeedModal
            userFeed={userFeed}
            textArea={textareaRef}
            refetch={refetch}
            openModal={openModal}
            onClose={handleOnClose}
            feedLikes={feedLikes}
            inputArea={inputArea}
            refetchLikes={refetchLikes}
            loadings={loadings}
            setLoadings={setLoadings}
            loadingLikes={loadLikes}
            feedImages={medias.imageUrl}
            feedVideo={medias.videoUrl}
            index={index}
            isLoading={isLoading}
            key={userFeed?.createdAt && userFeed.id && 21}
            isLocked={isLocked}
            modalRemove={modalRemove}
            setModalRemove={setModalRemove}
          />
        ))}
      </div>
    </div>
  );
};

export default UserFeedList;
